var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "flex h-full bg-pure-white",
      attrs: { id: "credit-transaction" }
    },
    [
      _c(
        "div",
        { staticClass: "flex flex-col flex-grow pt-2" },
        [
          _c(
            "div",
            {
              staticClass:
                "sticky z-50 flex items-center justify-between top-18 left-6 h-18 bg-pure-white",
              style: { width: "calc(100vw - 3rem - 0.5rem)" },
              attrs: { id: "credit-title" }
            },
            [
              _c("div", { staticClass: "flex flex-col gap-1" }, [
                _c(
                  "div",
                  { staticClass: "flex items-center gap-2" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "px-2 py-2 border border-slate-400",
                        style: {
                          borderRadius: "4px",
                          backgroundColor: "#F4F3FF"
                        }
                      },
                      [
                        _c("BlIcon", {
                          staticClass: "w-6 h-6",
                          attrs: { icon: "piggy" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("BlTextTitle4", { attrs: { text: "Credits" } })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex items-center gap-3" }, [
                _c(
                  "div",
                  { staticClass: "flex items-center gap-2" },
                  [
                    _c("BlSort", {
                      attrs: {
                        options: _vm.sortOptions,
                        defaultValue: { primary: "date", secondary: "desc" }
                      },
                      on: {
                        change: function($event) {
                          return _vm.onChangeSort($event)
                        }
                      },
                      model: {
                        value: _vm.sortInput,
                        callback: function($$v) {
                          _vm.sortInput = $$v
                        },
                        expression: "sortInput"
                      }
                    }),
                    _vm._v(" "),
                    _c("BlInputFilterAdvance", {
                      attrs: { bubbleCount: "", input: _vm.filterInput },
                      on: { changed: _vm.onChangeFilter }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "h-10 w-0.5 bg-slate-300" }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex gap-2" },
                  [
                    _c("BlInputButton", {
                      attrs: { type: "outlined", label: "Export as PDF" },
                      on: {
                        clicked: function($event) {
                          _vm.exportOpened = true
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.currentUser.role.includes("admin")
                      ? _c("BlInputButton", {
                          attrs: { icon: "plus", label: "Credit transaction" },
                          on: {
                            clicked: function($event) {
                              _vm.newTransactionOpened = true
                            }
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            ]
          ),
          _vm._v(" "),
          _vm.exportOpened
            ? _c("ExportCreditTransactionModal", {
                on: {
                  "close-modal": function($event) {
                    _vm.exportOpened = false
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.newTransactionOpened
            ? _c("NewCreditTransactionModal", {
                on: {
                  "after-commit": _vm.fetchCreditTransactions,
                  "close-modal": function($event) {
                    _vm.newTransactionOpened = false
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.pageLoading && _vm.creditDetails
            ? _c(
                "div",
                {
                  staticClass: "sticky flex gap-3 mb-4 left-6",
                  style: { width: "calc(100vw - 3rem - 0.5rem)" },
                  attrs: { id: "credit-details" }
                },
                [
                  _c("CreditDetails", {
                    attrs: {
                      title: "Available session credits",
                      expiringSoon:
                        _vm.creditDetails.session_credits.expiring_soon,
                      available: _vm.creditDetails.session_credits.available,
                      used: _vm.creditDetails.session_credits.used,
                      usePanel: ""
                    },
                    on: {
                      "open-panel": function($event) {
                        return _vm.onOpenPanel("available")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("CreditDetails", {
                    attrs: {
                      title: "Reschedule credits",
                      expiringSoon:
                        _vm.creditDetails.reschedule_credits.expiring_soon,
                      available: _vm.creditDetails.reschedule_credits.available,
                      used: _vm.creditDetails.reschedule_credits.used,
                      usePanel: ""
                    },
                    on: {
                      "open-panel": function($event) {
                        return _vm.onOpenPanel("reschedule")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("CreditDetails", {
                    attrs: {
                      title: "Scheduled sessions",
                      totalSessions:
                        _vm.creditDetails.scheduled_credits.total_sessions,
                      totalCredits:
                        _vm.creditDetails.scheduled_credits.total_credits,
                      usePanel: ""
                    },
                    on: {
                      "open-panel": function($event) {
                        return _vm.onOpenPanel("scheduled")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("CreditDetails", {
                    attrs: {
                      title: "Current balance",
                      currentBalance: _vm.creditDetails.current_balance
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.pageLoading
            ? _c("div", { staticClass: "grid h-128 place-items-center" }, [
                _c("div", { staticClass: "blum-loader" })
              ])
            : !_vm.creditTransactions.length
            ? _c(
                "div",
                { staticClass: "grid h-128 place-items-center" },
                [
                  _c("BlTextBody1", {
                    staticClass: "text-center",
                    attrs: {
                      text: "All credit transactions will be displayed here."
                    }
                  })
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "mb-4" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "sticky z-20 flex items-center rounded-t top-36",
                      attrs: { id: "credit-header" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "sticky left-0 z-10 flex pl-6 bg-pure-white"
                        },
                        [
                          _c(
                            "BlTooltip",
                            {
                              staticClass:
                                "flex items-center flex-shrink-0 w-20 h-12 px-4 border-t border-l rounded-tl bg-slate-300 border-slate-400"
                            },
                            [
                              _c("BlTextSubtitle3", {
                                staticClass: "truncate",
                                attrs: { text: "ID" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "BlTooltip",
                            {
                              staticClass:
                                "flex items-center flex-shrink-0 w-40 h-12 px-4 border-t border-r bg-slate-300 border-slate-400"
                            },
                            [
                              _c("BlTextSubtitle3", {
                                staticClass: "truncate",
                                attrs: { text: "Date created" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "BlTooltip",
                        {
                          staticClass:
                            "flex items-center flex-shrink-0 h-12 px-4 border-t w-50 bg-slate-300 border-slate-400"
                        },
                        [
                          _c("BlTextSubtitle3", {
                            staticClass: "truncate",
                            attrs: { text: "Accountable" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "BlTooltip",
                        {
                          staticClass:
                            "flex items-center flex-shrink-0 h-12 px-4 border-t w-35 bg-slate-300 border-slate-400"
                        },
                        [
                          _c("BlTextSubtitle3", {
                            staticClass: "truncate",
                            attrs: { text: "Type" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "BlTooltip",
                        {
                          staticClass:
                            "flex items-center flex-shrink-0 h-12 px-4 border-t w-50 bg-slate-300 border-slate-400"
                        },
                        [
                          _c("BlTextSubtitle3", {
                            staticClass: "truncate",
                            attrs: { text: "Item" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "BlTooltip",
                        {
                          staticClass:
                            "flex items-center flex-shrink-0 h-12 px-4 border-t w-35 bg-slate-300 border-slate-400"
                        },
                        [
                          _c("BlTextSubtitle3", {
                            staticClass: "truncate",
                            attrs: { text: "Session#" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "BlTooltip",
                        {
                          staticClass:
                            "flex items-center flex-shrink-0 h-12 px-4 border-t w-35 bg-slate-300 border-slate-400"
                        },
                        [
                          _c("BlTextSubtitle3", {
                            staticClass: "truncate",
                            attrs: { text: "Reschedule#" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "BlTooltip",
                        {
                          staticClass:
                            "flex items-center flex-shrink-0 h-12 px-4 border-t w-50 bg-slate-300 border-slate-400"
                        },
                        [
                          _c("BlTextSubtitle3", {
                            staticClass: "truncate",
                            attrs: { text: "Amount" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "BlTooltip",
                        {
                          staticClass:
                            "flex items-center flex-shrink-0 h-12 px-4 border-t w-35 bg-slate-300 border-slate-400",
                          scopedSlots: _vm._u([
                            {
                              key: "tooltip",
                              fn: function() {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex flex-col w-40 gap-1 text-center"
                                    },
                                    [
                                      _vm._v(
                                        "\n              The expiration date is the deadline to use credits for booking;\n              once booked, they stay valid even if the appointment occurs\n              later.\n            "
                                      )
                                    ]
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ])
                        },
                        [
                          _vm._v(" "),
                          _c("BlTextSubtitle3", {
                            staticClass: "truncate",
                            attrs: { text: "Expiration date" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "BlTooltip",
                        {
                          staticClass:
                            "flex items-center flex-grow flex-shrink-0 h-12 px-4 border-t w-100 bg-slate-300 border-slate-400"
                        },
                        [
                          _c("BlTextSubtitle3", {
                            staticClass: "truncate",
                            attrs: { text: "Reason" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "sticky right-0 z-10 flex pr-6 bg-pure-white"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex items-center flex-shrink-0 h-12 px-4 border-t border-r rounded-tr w-30 bg-slate-300 border-slate-400"
                            },
                            [_c("BlTextSubtitle3", { attrs: { text: "" } })],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.creditTransactions, function(credit, idx) {
                    return _c("CreditItem", {
                      key: credit.id,
                      attrs: {
                        credit: credit,
                        isLast: idx + 1 === _vm.creditTransactions.length
                      }
                    })
                  })
                ],
                2
              ),
          _vm._v(" "),
          _vm.totalCreditTransactions > 25
            ? _c(
                "div",
                { staticClass: "flex mb-36" },
                [
                  _c("BlInputPagination", {
                    staticClass: "sticky left-6",
                    style: { width: "calc(100vw - 3rem - 0.5rem)" },
                    attrs: {
                      page: _vm.page,
                      perPage: _vm.perPage,
                      total: _vm.totalCreditTransactions
                    },
                    on: {
                      changed: _vm.changePage,
                      "changed-per-page": _vm.changePerPage
                    }
                  })
                ],
                1
              )
            : _c("div", { staticClass: "mb-46" })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "fixed top-0 flex flex-col overflow-y-auto transition-all duration-300 border w-116 bg-pure-white border-slate-400",
          class: [_vm.panelOpened ? "right-0" : "-right-116"],
          style: { height: "calc(100vh)", zIndex: 101 },
          attrs: { "data-id": _vm.panelId, id: "panel-details" }
        },
        [
          _vm.panelSection === "available"
            ? _c("AvailableCreditsPanel", { attrs: { panelId: _vm.panelId } })
            : _vm._e(),
          _vm._v(" "),
          _vm.panelSection === "reschedule"
            ? _c("RescheduleCreditsPanel", { attrs: { panelId: _vm.panelId } })
            : _vm._e(),
          _vm._v(" "),
          _vm.panelSection === "scheduled"
            ? _c("ScheduledSessionsPanel", { attrs: { panelId: _vm.panelId } })
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6662040a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6662040a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/ClientCredit.vue
// module id = null
// module chunks = 